export const STORE_ACTION_LABELS = {
  VIEW: "Visualizar",
  CONTINUE: "Continuar",
  RECONCILE: "Conciliar",
} as const;
